<template>
  <a
    href="javascript:;"
    @click="click"
    class="weui-btn"
    role="button"
    :class="[
      'weui-btn_' + type,
      'weui-btn-size_' + size,
      {
        'weui-btn_disabled': disabled,
        'weui-btn_ghost': ghost,
      },
    ]"
  >
    <slot></slot>
  </a>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

// storybook: https://wphk-ui.pages.woa.com/?path=/story/button--primary
@Component
export default class FitButton extends Vue {
  /** 按钮类型 */
  @Prop({ default: 'primary' }) public type!: 'primary' | 'warn' | 'default' | 'disabled' | 'secondary' | 'secondaryNew';
  /** 按钮大小 */
  @Prop({ default: 'normal' }) public size!: 'normal' | 'small';
  /** 是否禁用，根据 type 类型为 primary/secondary 有不同的表现  */
  @Prop({ default: false }) public disabled!: boolean;
  /** 幽灵按钮，在设计规范中没有，通常不会用到 */
  @Prop({ default: false }) public ghost!: boolean;

  public click() {
    if (this.disabled || this.type === 'disabled') {
      return;
    }
    this.$emit('click');
  }
}
</script>
